import axios from 'axios';
import { API_BASE_URL } from "../constants";

export const trackCampaignVisit = async (slug) => {
  try {
    const res = await axios.get(`${API_BASE_URL}api/campaigns/public/${slug}/connect`);
    return res.data; 
  } catch (error) {
    console.error('Error tracking campaign visit:', error);
    throw error;
  }
};

export const updateEngagementTime = async (reportId, engagementMs) => {
  try {
    await axios.patch(`${API_BASE_URL}api/campaigns/campaigns/reports/${reportId}`, {
      engagementMs,
    });
  } catch (error) {
    console.error('Error updating engagement time:', error);
  }
};
